exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".olapic.olapic_items_0 #olapic-slider-widget.olapic-slider-widget{margin:auto}", ""]);

